export class Message {
  constructor(public name: string, public payload: any) {}
}
